import { createContext, useContext, useState } from 'react';

const RequestNotificationContext = createContext();

export const RequestNotificationProvider = ({ children }) => {
  const [requestCount, setRequestCount] = useState(0);

  return (
    <RequestNotificationContext.Provider
      value={{ requestCount, setRequestCount }}
    >
      {children}
    </RequestNotificationContext.Provider>
  );
};

// Custom hook so components can easily access the context
export const useRequestNotification = () =>
  useContext(RequestNotificationContext);
